export default "__VITE_ASSET__ZG0wxWts__"